import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { BarcodeDirective } from './directives/barcode.directive';
import { CurrencyMaskDirective } from './directives/currency-mask.directive';
import { NumberValidationDirective } from './directives/number-validation.directive';
import { TextValidationDirective } from './directives/text-validation.directive';
import { MaterialModule } from './material.module';
import { FilePreviewPipe } from './pipes/file-preview.pipe';
import { RentalDurationPipe } from './pipes/rental-duration.pipe';
import { TitleCaseKeyPipe } from './pipes/title-case-key.pipe';
import { UtcToLocalTimePipe } from './pipes/utc-tolocal-time.pipe';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgbModule,
    BarcodeDirective,
    MatStepperModule,
    TitleCaseKeyPipe,
    ReactiveFormsModule,
    FilePreviewPipe,
    NumberValidationDirective,
    UtcToLocalTimePipe,
    RentalDurationPipe,
    CurrencyMaskDirective,
    TextValidationDirective,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgbModule,
    BarcodeDirective,
    TitleCaseKeyPipe,
    FilePreviewPipe,
    NumberValidationDirective,
    UtcToLocalTimePipe,
    RentalDurationPipe,
    CurrencyMaskDirective,
    TextValidationDirective,
  ],
  providers: [],
})
export class SharedModule {}
